import { render, staticRenderFns } from "./ArboNode.vue?vue&type=template&id=2532e362&scoped=true&"
import script from "./ArboNode.vue?vue&type=script&lang=js&"
export * from "./ArboNode.vue?vue&type=script&lang=js&"
import style0 from "./ArboNode.vue?vue&type=style&index=0&id=2532e362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532e362",
  null
  
)

export default component.exports